import { StyledAlert } from "App/global-style";
import { CoverageComparison } from "Components/CoverageComparison";
import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { useTexts } from "Components/TextContext";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { FormikProps } from "formik";
import React from "react";
import { HouseContentsProductPriceFormValues } from "../houseContentsFormValuesInterfaces";

interface Props {
  coverages: CoveragePriceCalculation[];
  formProps: FormikProps<HouseContentsProductPriceFormValues>;
  unableToBuySuper?: boolean;
}

export const HouseContentsPriceElements = ({
  formProps,
  coverages,
  children,
  unableToBuySuper,
}: React.PropsWithChildren<Props>): React.ReactElement => {
  const { getText } = useTexts();
  return (
    <>
      {coverages.length > 0 ? (
        <>
          {children}
          {unableToBuySuper && (
            <StyledAlert
              title={getText("housecontentsform.alerttitle.nosuperalert")}
            />
          )}

          {!unableToBuySuper && (
            <CoverageComparison
              productBackendName={ProductBackendName.HOUSE_CONTENTS}
              selectedCoverage={formProps.values.coverage}
            />
          )}
          <CurrentPriceMessage
            productBackendName={ProductBackendName.HOUSE_CONTENTS}
            coverages={coverages}
            selectedPrices={[
              {
                selectedCoverage: formProps.values.coverage,
                selectedDeductible: formProps.values.deductible,
                defaultDeductible: undefined,
              },
            ]}
          />
        </>
      ) : (
        <ThemedSpinner />
      )}
    </>
  );
};
